import * as React from 'react';
import './TrackingSearchBar.scss';
import DateRangeModel from 'src/model/dateRange.model';

export interface ITrackSearchBarProps {
  t: any;
  mode: 'Desktop' | 'Mobile';
  filters: {
    dates: DateRangeModel | null;
    search: string;
  };
  handleSearchText: (e: any) => void;
  handleOnClickSearch: () => void;
}

class TrackingSearchBar extends React.Component<ITrackSearchBarProps, any> {
  public render() {
    const { t } = this.props;
    return (
      <div
        className={`rp-tracking--search-bar${
          this.props.mode === 'Desktop' ? '' : '-mobile'
        }`}
      >
        <div
          className={`rp-tracking--search-bar--view-container${
            this.props.mode === 'Desktop' ? '' : '-mobile'
          }`}
        >
          <div
            className={`rp-tracking-search-bar--view${
              this.props.mode === 'Desktop' ? '' : '-mobile'
            }`}
          >
            <div
              className={`rp-tracking-searchbar--order${
                this.props.mode === 'Desktop' ? '' : '-mobile'
              }`}
            >
              <div className="title">
                <span>{t('common.searchBy')}:</span>
              </div>
              <div className="rp-tracking--searchbar--elements">
                <input
                  placeholder={t('myOrders.searchByKeys.orderNumber')}
                  className={`rp-tracking--search-bar--input${
                    this.props.mode === 'Desktop' ? '' : '-mobile'
                  }`}
                  onChange={this.props.handleSearchText}
                  value={this.props.filters.search}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      this.props.handleOnClickSearch();
                    }
                  }}
                />
                <button
                  onClick={this.props.handleOnClickSearch}
                  className={`primary-button rp-tracking--search-bar--search${
                    this.props.mode === 'Desktop' ? '' : '-mobile'
                  }`}
                >
                  <label>{t('common.search')}</label>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TrackingSearchBar;
